<app-widget-spinner *ngIf="isPending$ | async" [loadingHintTranslationKey]="loadingHintTranslationKey"/>
<mat-error *ngIf="error"><i>{{ error }}</i></mat-error>